<div class="main-content">
  <h1><i class="back material-icons" (click)='closeView()'>arrow_back</i><span>Your voucher codes</span></h1>
  <div class="new-card merchant {{merchant.merchantName | lowercase}}" *ngFor="let merchant of voucherMerchants">
    <div class="merchant-header">
      <div class="name-wrapper">
        <div class="loan-icon">
          <div class="img"
            [style.background-image]="'url(' + s3Url + '/logo-icons/' + (merchant.merchantName | lowercase) + '-logo-icon.png)'">
          </div>
        </div>
        <div class="name">{{merchant.merchantName}}</div>
      </div>
      <div class="total-loan-amount">
        {{merchant.totalValue | RupeeCurrencyPipe}}
      </div>
    </div>
    <div class="voucher-list" [class.all]="allVouchers"
      [class.more]="(!allVouchers && merchant.vouchers.length > 2) || merchant.isOffline">
      <div class="new-card secondary voucher" *ngFor="let voucher of merchant.vouchers">
        <div class="code-wrapper">
          <div class="copy-info code">
            <div>
              <div class="label">Voucher Code</div>
              <div class="copy-content">{{voucher.voucherCode}}</div>
            </div>
            <div title="Copy Voucher Code" class="copy" (click)="copyToClipboard(voucher.voucherCode)"></div>
          </div>
          <div class="copy-info pin">
            <div>
              <div class="label">Voucher Pin</div>
              <div class="copy-content">{{voucher.voucherPin}}</div>
            </div>
            <div title="Copy Voucher Pin" class="copy" (click)="copyToClipboard(voucher.voucherPin)"></div>
          </div>
        </div>
        <div class="code-wrapper">
          <div class="amount">
            <div class="label">Amount</div>
            <div>{{voucher.voucherValue | RupeeCurrencyPipe}}</div>
          </div>
          <button *ngIf="((voucher.merchantName | lowercase) === 'amazonpay') || ((voucher.merchantName | lowercase) === 'flipkart')" (click)="claimCode(voucher)"
            class="btn zest-btn outline"><span [textContent]="(voucher.merchantName | lowercase) === 'amazonpay' ? 'ADD ON AMAZON' : 'GO TO FLIPKART'"></span></button>
        </div>
      </div>
    </div>
    <div class='footer' *ngIf="(!allVouchers && merchant.vouchers.length > 2) || merchant.isOffline">
      <a class="more" *ngIf="!allVouchers && merchant.vouchers.length > 2" (click)="showAllVouchers()">
        + {{merchant.vouchers.length - 2}} more <i class="arrow material-icons">expand_more</i>
      </a>
      <a class="tnc" *ngIf="merchant.isOffline" (click)="toggleTnCView('open', merchant.merchantName)">View T&C</a>
    </div>
  </div>
  <!-- Redemption Info -->
  <zest-how-to-redeem-card [vouchers]="vouchers"></zest-how-to-redeem-card>
</div>
<!-- Terms and Condition -->
<div id="tnc" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal">
  <zest-tnc-card *ngIf="tncMerchant" [merchantName]="tncMerchant" (close)="toggleTnCView('close')"></zest-tnc-card>
</div>
